import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {htmlData,} from "../../../pages/management-elements/elements-page/elements-page.component";
import {UntypedFormGroup} from "@angular/forms";
import {stringIsSet} from "../../../providers/service/global-variables.service";
import {typeFormValue} from "../../../configurationProperty/configurationPropertyUtils";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Observable} from "rxjs";

@Component({
    selector: 'app-form-by-html-data-obj-form',
    templateUrl: './form-by-html-data-obj-form.component.html',
    styleUrls: ['./form-by-html-data-obj-form.component.scss'],
    standalone: false
})
export class FormByHtmlDataObjFormComponent implements OnInit {

    public class = '';
    public disabledSaveButton = false;
    private defaultValue: { [k: string]: any } = {};

    constructor(public dialogRef: MatDialogRef<FormByHtmlDataObjFormComponent>,
                @Inject(MAT_DIALOG_DATA) public data: {
                    form: UntypedFormGroup,
                    htmlData: htmlData[],
                    visualizedInTabGroup: boolean,
                    getTraduction: (val: any) => string,
                    resizeClass: string
                }) {
        Object.keys(this.form.value).forEach(key => {
            if (this.form.get(key)?.value != null) {
                this.defaultValue[key] = this.form.get(key)?.value;
            }
        });
    }

    ngOnInit(): void {
        if (stringIsSet(this.data.resizeClass)) {
            this.class = this.data.resizeClass;
        } else {
            this.class = '';
        }
    }


    clickSaveButton(): void {
        this.dialogRef.close(this.form);
    }


    get visualizedInTabGroup(): boolean {
        return this.data.visualizedInTabGroup;
    }

    get form(): UntypedFormGroup {
        return this.data.form;
    }

    get htmlData(): htmlData[] {
        return this.data.htmlData;
    }

    unsetValue(label: string, type: typeFormValue | undefined): void {
        let value;
        if (type != null && type === typeFormValue.CHECKBOX) {
            value = this.defaultValue[label];
        }
        this.form.get(label)?.reset(value);
        this.form.get(label)?.markAsPristine();
    }
}
